type ConstraintViolationError = {
  status: number;
  title: string;
  type: string;
  violations: Array<{ field: string; message: string }>;
};

type StandardError = {
  detail: string;
  errorKey: string;
  status: number;
  title: string;
};

const CONSTRAIN_VIOLATION = 'https://zalando.github.io/problem/constraint-violation';

export const APIResponseHelper = (response: ConstraintViolationError & StandardError): string => {
  if (response?.type === CONSTRAIN_VIOLATION) {
    const violation = response?.violations?.[0];
    return `${violation?.field}.${violation?.message}`;
  }

  switch (response?.status) {
    case 401:
      return 'resourceNotFound';
    case 500:
      return 'fail';
    case 403:
      return 'forbidden';
    default:
      return response?.errorKey;
  }
};

export const handleAPIError = (error: any) => {
  if (error) {
    const data = (error as any).data;

    if (data?.error === 'invalid_token') {
      return 'invalid_token';
    }

    const systemError = APIResponseHelper(data || error);

    if (systemError) {
      const errorKey = systemError ? `api.error.${systemError}` : 'common.toast.fail';

      return errorKey;
    }
  }

  return null;
};
